import { CONSTANTS } from 'client/utils/constants';
import { formatPrice } from 'utils';
import { Tooltip,Label } from '../../../../CommonComponents';
import './AssetDispositionAndLocation.scss'

const AssetDispositionAndLocation = (props: any) => {
  const detailsByIdItem = props?.detailsByIdItem;
  const isValidForPenaltyFee = props?.isValidForPenaltyFee;
  return (
    <>
      <div className={`borderCard-assetApproval pendingApprovalOrder ${props.viewtype == 'orderdetail-view' ? 'asset-location-dispostion' : ''}`}>
       
      { detailsByIdItem?.orderRequestType == CONSTANTS?.DISPOSITION_REQUEST ? <div className={`Disposition-request-width Disposition-request ${detailsByIdItem?.dispositionType?.toLowerCase().includes("write-off") ? 'write-off-case' : ''} ${(
        detailsByIdItem?.dispositionType == CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY
         || detailsByIdItem?.dispositionType == CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY
         ) ? (`third-party ${detailsByIdItem?.dispositionType?.toLowerCase().includes("write-off") ? 'Asset_Location_Order_NA' : ''}`) : (detailsByIdItem?.dispositionType == CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_OWNED || detailsByIdItem?.dispositionType == CONSTANTS.DISPOSITION_CHOICES.FMC_AUCTION_LEASED) ? (`special-case ${detailsByIdItem?.dispositionType?.toLowerCase().includes("write-off") ? 'Asset_Location_Order_NA' : ''}`): ''}`}>
      
      <><div className="blueLabel pull-left my-2">Asset Location</div>
      {!detailsByIdItem?.dispositionType?.toLowerCase().includes("write-off") ?
      <>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label">Location Name</Label>
        <Tooltip content={detailsByIdItem?.assetLocationAddress?.locationName || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip">
          <div className="content" >{detailsByIdItem?.assetLocationAddress?.locationName || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_2">Contact Name</Label>
        <Tooltip content={detailsByIdItem?.assetLocationAddress?.contactName || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_2">
          <div className="content" >{detailsByIdItem?.assetLocationAddress?.contactName || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_3">Email</Label>
        <Tooltip content={detailsByIdItem?.assetLocationAddress?.assetEmail || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_3">
          <div className="content" >{detailsByIdItem?.assetLocationAddress?.assetEmail || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_4">Contact Phone #</Label>
        <Tooltip content={detailsByIdItem?.assetLocationAddress?.assetPhoneNo || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_4">
          <div className="content" >{detailsByIdItem?.assetLocationAddress?.assetPhoneNo || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_5">Address</Label>
        <Tooltip content={(detailsByIdItem.assetLocationAddress?.addLine1 ? detailsByIdItem.assetLocationAddress?.addLine1 + ', ' : "" )+ ( detailsByIdItem.assetLocationAddress?.addLine2 ? detailsByIdItem.assetLocationAddress?.addLine2 + ', ' : "" ) + (detailsByIdItem.assetLocationAddress?.assetCity ? detailsByIdItem.assetLocationAddress?.assetCity + ', ' : "") + (detailsByIdItem.assetLocationAddress?.assetState ? detailsByIdItem.assetLocationAddress?.assetState + ', ' : "") + (detailsByIdItem.assetLocationAddress?.assetZip ? detailsByIdItem.assetLocationAddress?.assetZip : "") || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_5">
          <div className="content" >{(detailsByIdItem.assetLocationAddress?.addLine1 ? detailsByIdItem.assetLocationAddress?.addLine1 + ', ' : "" )+ ( detailsByIdItem.assetLocationAddress?.addLine2 ? detailsByIdItem.assetLocationAddress?.addLine2 + ', ' : "" ) + (detailsByIdItem.assetLocationAddress?.assetCity ? detailsByIdItem.assetLocationAddress?.assetCity + ', ' : "") + (detailsByIdItem.assetLocationAddress?.assetState ? detailsByIdItem.assetLocationAddress?.assetState + ', ' : "") + (detailsByIdItem.assetLocationAddress?.assetZip ? detailsByIdItem.assetLocationAddress?.assetZip : "") || '-'}</div>
        </Tooltip>
      </div></>
      : 
            <p className="mb-2">
              N/A</p>}</> 
      <div className="blueLabel pull-left my-2">Asset Disposition</div>
      {/*<div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_6">Process Type</Label>
        <Tooltip content={detailsByIdItem?.processType || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_6">
          <div className="content" >{detailsByIdItem?.processType || '-'}</div>
        </Tooltip>
  </div>*/}
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_7">Disposition Choice</Label>
        <Tooltip content={detailsByIdItem?.dispositionType || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_7">
          <div className="content" >{detailsByIdItem?.dispositionType || '-'}</div>
        </Tooltip>
      </div>
          <div>{
            (isValidForPenaltyFee(detailsByIdItem?.dispositionType) && detailsByIdItem?.assets[0]?.dispositionPenaltyFee > 0) && detailsByIdItem?.assets[0]?.isRequestWriteOffPentaltyExemption ?
              <><Label data-attribute="AssetDispositionAndLocation_Default_Label_8">Penalty Exemption Reason</Label>
                <Tooltip content={detailsByIdItem?.assets[0]?.penaltyExemptionReason || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_8">
                  <div className="content" >{detailsByIdItem?.assets[0]?.penaltyExemptionReason || '-'}</div>
                </Tooltip></>
              : ''
          }</div>
      {(detailsByIdItem?.dispositionType == "Sell To, Leased") &&
      <>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_9">Sell To, Leased</Label>
        <Tooltip content={detailsByIdItem?.dispositionSubType || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_9">
          <div className="content" >{detailsByIdItem?.dispositionSubType || '-'}</div>
        </Tooltip>
      </div>
      </>
      }
      {(detailsByIdItem?.dispositionType == "Sell To, Owned") &&
      <>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_10">Sell To, Owned</Label>
        <Tooltip content={detailsByIdItem?.dispositionSubType || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_10">
          <div className="content" >{detailsByIdItem?.dispositionSubType || '-'}</div>
        </Tooltip>
      </div>
      </>
      }
      {(detailsByIdItem?.dispositionType == "FMC Auction, Leased") &&
      <>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_11">FMC Auction, Leased</Label>
        <Tooltip content={detailsByIdItem?.dispositionSubType || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_11">
          <div className="content" >{detailsByIdItem?.dispositionSubType || '-'}</div>
        </Tooltip>
      </div>
      </>
      }
      {(detailsByIdItem?.dispositionType == "FMC Auction, Owned") &&
      <>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_12">FMC Auction, Owned</Label>
        <Tooltip content={detailsByIdItem?.dispositionSubType || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_12">
          <div className="content" >{detailsByIdItem?.dispositionSubType || '-'}</div>
        </Tooltip>
      </div>
      </>
      }
      {(
        detailsByIdItem?.dispositionType == CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY
         || detailsByIdItem?.dispositionType == CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY
         ) ?
      <>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_13">Name</Label>
        <Tooltip content={detailsByIdItem?.assetDispositionAddress?.destinationName || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_13">
          <div className="content" >{detailsByIdItem?.assetDispositionAddress?.destinationName || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_14">Address 1</Label>
        <Tooltip content={detailsByIdItem.assetDispositionAddress?.addLine1 || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_14">
          <div className="content" >{detailsByIdItem.assetDispositionAddress?.addLine1 || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_15">Address 2</Label>
        <Tooltip content={detailsByIdItem.assetDispositionAddress?.addLine2 || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_15">
          <div className="content" >{detailsByIdItem.assetDispositionAddress?.addLine2 || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_16">City</Label>
        <Tooltip content={detailsByIdItem.assetDispositionAddress?.assetCity || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_16">
          <div className="content" >{detailsByIdItem.assetDispositionAddress?.assetCity || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_17">State</Label>
        <Tooltip content={ detailsByIdItem.assetDispositionAddress?.assetState || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_17">
          <div className="content" >{ detailsByIdItem.assetDispositionAddress?.assetState || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_18">Zip Code</Label>
        <Tooltip content={detailsByIdItem.assetDispositionAddress?.assetZip || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_18">
          <div className="content" >{detailsByIdItem.assetDispositionAddress?.assetZip || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_19">Phone #</Label>
        <Tooltip content={detailsByIdItem.assetDispositionAddress?.assetPhoneNo || '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_19">
          <div className="content" >{detailsByIdItem.assetDispositionAddress?.assetPhoneNo || '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_20">Sale price</Label>
        <Tooltip content={detailsByIdItem.assetDispositionAddress?.thirdPartySalePrice != null ? `$ ${formatPrice(detailsByIdItem.assetDispositionAddress?.thirdPartySalePrice, 2)}` : '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_20">
          <div className="content" >{detailsByIdItem.assetDispositionAddress?.thirdPartySalePrice != null ? `$ ${formatPrice(detailsByIdItem.assetDispositionAddress?.thirdPartySalePrice, 2)}` : '-'}</div>
        </Tooltip>
      </div>
      <div>
        <Label data-attribute="AssetDispositionAndLocation_Default_Label_21">Total price</Label>
        <Tooltip content={detailsByIdItem.assetDispositionAddress?.thirdPartyTotalPrice != null ? `$ ${formatPrice(detailsByIdItem.assetDispositionAddress?.thirdPartyTotalPrice, 2)}` : '-'} data-attribute="AssetDispositionAndLocation_Default_Tooltip_21">
          <div className="content" >{detailsByIdItem.assetDispositionAddress?.thirdPartyTotalPrice != null ? `$ ${formatPrice(detailsByIdItem.assetDispositionAddress?.thirdPartyTotalPrice, 2)}` : '-'}</div>
        </Tooltip>
      </div>
      </> : ""
      }
        </div> : ''
        }
      </div>
    </>
  )
}

export default AssetDispositionAndLocation;